import AbstractCollection from "./abstractCollection";

class MessageCollection extends AbstractCollection {
  /**
   *
   * @param {Message[]} messages
   * @param {Message[]} replies
   */
  constructor(messages, replies) {
    super(messages);
    this.items = null;
    this.replies = null;

    this.loaded = !!messages && !!replies;

    if (this.loaded) {
      this.items = messages;
      this.replies = replies;
    }
  }

  /**
   *
   * @param {string} id
   * @param {boolean} [throwError=true]
   * @returns {null|Team}
   */
  getMessageById(id, throwError = true) {
    return this.getItem({ id }, throwError);
  }

  /**
   *
   * @param {string} messageId
   * @returns {Message[]}
   */
  getReplies(messageId) {
    let replies = [];
    const message = this.getMessageById(messageId);
    message.obj.replies.forEach((replyId) => {
      let matches = this.replies.filter((reply) => reply.obj.id === replyId);
      if (matches.length >= 1) {
        replies.push(matches[0]);
      } else {
        throw new Error(
          `MessageCollection.getReplies() - ERROR - Could not find reply ${replyId}`
        );
      }
    });

    return replies;
  }
}

export default MessageCollection;
